import { colorsPrimitive as colors } from "./colorsPrimitive";

export const colorsBorder = {
	border_primary: colors.primary.grayLight[300],
	border_primary_dark: colors.primary.grayDark[700],

	border_secondary: colors.primary.grayLight[200],
	border_secondary_dark: colors.primary.grayDark[800],
	border_secondary_alt: "rgba(0, 0, 0, 0.08)",
	border_secondary_alt_dark: colors.primary.grayDark[800],

	border_tertiary: colors.primary.grayLight[100],
	border_tertiary_dark: colors.primary.grayDark[800],

	border_disabled: colors.primary.grayLight[300],
	border_disabled_dark: colors.primary.grayDark[700],
	border_disabled_subtle: colors.primary.grayLight[200],
	border_disabled_subtle_dark: colors.primary.grayDark[800],

	border_brand: colors.primary.brand[500],
	border_brand_dark: colors.primary.brand[400],
	border_brand_alt: colors.primary.brand[600],
	border_brand_alt_dark: colors.primary.grayDark[700],

	border_error: colors.primary.error[500],
	border_error_dark: colors.primary.error[400],
	border_error_subtle: colors.primary.error[300],
	border_error_subtle_dark: colors.primary.error[500],
};
